import React from 'react';
import Relay from 'react-relay/classic';
import { ActivityIndicator } from '@lyearn-team/frontend-components';

const RelayQueryRendererLegacy = ({
  Component,
  query,
  renderComponentWithLoading = false,
  renderNullOnLoading = false,
  extraComponentProps,
  ...otherProps
}) => (
  <Relay.Renderer
    Container={Component}
    environment={Relay.Store}
    queryConfig={query}
    render={({ props, done, error }) => {
      if (error) {
        return (
          <Component
            error={error}
            {...extraComponentProps}
            {...(extraComponentProps
              && extraComponentProps.match
              && extraComponentProps.match.params)}
            environment={Relay.Store}
          />
        );
      }
      if (done && props) {
        return (
          <Component
            {...extraComponentProps}
            {...(extraComponentProps
              && extraComponentProps.match
              && extraComponentProps.match.params)}
            {...props}
            environment={Relay.Store}
          />
        );
      }

      if (renderComponentWithLoading) {
        return (
          <Component
            loading={true}
            {...extraComponentProps}
            {...(extraComponentProps
              && extraComponentProps.match
              && extraComponentProps.match.params)}
            {...props}
            environment={Relay.Store}
          />
        );
      }

      if (renderNullOnLoading) {
        return null;
      }

      return <ActivityIndicator.FullScreenV2 />;
    }}
    {...otherProps}
  />
);

export default RelayQueryRendererLegacy;
